let errorNotifier = (error) => {
  console.log(error);
}

export default errorNotifier;
